import { useState, useEffect, useCallback } from 'react'
import { api } from '../lib/api'
import toast from 'react-hot-toast'
import { Empty } from '../components/UI'

const ACTION_COLORS = { login:'#6366F1', create:'var(--accent3)', edit:'#F59E0B', delete:'#EF4444' }
const SECTION_LABELS = {
  products:'Product Research', funnel_building:'Funnel Building', creatives:'Creatives',
  ad_copy:'Ad Copy', ad_scheduling:'Ad Scheduling', creative_requests:'Creative Requests',
  asset_prep:'Asset Prep', winning_products:'Winning Products'
}

export default function ActivityLog() {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [expanded, setExpanded] = useState({})
  const [fAction, setFAction] = useState('')
  const [fSection, setFSection] = useState('')

  const load = useCallback(() => {
    setLoading(true)
    const params = []
    if (fAction) params.push(`action=${fAction}`)
    if (fSection) params.push(`section=${fSection}`)
    const q = params.length ? '?' + params.join('&') : ''
    api.getActivityLog(q).then(d => setLogs(Array.isArray(d) ? d : [])).catch(() => setLogs([])).finally(() => setLoading(false))
  }, [fAction, fSection])
  useEffect(() => { load() }, [load])

  const fmt = ts => { try { return new Date(ts).toLocaleString() } catch { return ts } }
  const val = v => v === null || v === undefined || v === '' ? '(empty)' : (typeof v === 'object' ? JSON.stringify(v) : String(v))

  const renderChanges = (log) => {
    const c = log.changes || {}
    if (log.action === 'login') return <span style={{color:'var(--text3)'}}>Signed in</span>
    if (log.action === 'delete') {
      const d = c.deleted || {}
      return <div style={{fontSize:12}}>Deleted record {d.market ? `(${d.market})` : ''}</div>
    }
    if (log.action === 'create') {
      const cr = c.created || {}
      return <div style={{fontSize:12,color:'var(--text2)'}}>Created: {Object.entries(cr).filter(([k])=>k!=='launch_markets').slice(0,6).map(([k,v])=>`${k}=${val(v)}`).join(', ')}</div>
    }
    // edit: show field-by-field old -> new
    const keys = Object.keys(c)
    if (!keys.length) return <span style={{color:'var(--text3)'}}>No field changes</span>
    return <div style={{display:'flex',flexDirection:'column',gap:4}}>
      {keys.map(k => (
        <div key={k} style={{fontSize:12,display:'flex',gap:8,flexWrap:'wrap'}}>
          <span style={{fontWeight:700,color:'var(--text2)',minWidth:120}}>{k}</span>
          <span style={{color:'#EF4444',textDecoration:'line-through',maxWidth:280,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{val(c[k].from)}</span>
          <span style={{color:'var(--text3)'}}>→</span>
          <span style={{color:'var(--accent3)',maxWidth:280,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{val(c[k].to)}</span>
        </div>
      ))}
    </div>
  }

  return (
    <div style={{display:'flex',flexDirection:'column',height:'100%'}}>
      <div className="toolbar">
        <div className="toolbar-left">
          <span className="toolbar-title">📋 Activity Log</span>
          <span className="toolbar-sub">{logs.length} entries</span>
        </div>
        <div style={{display:'flex',gap:8}}>
          <select value={fAction} onChange={e=>setFAction(e.target.value)} style={{background:'var(--bg3)',border:'1px solid var(--border2)',borderRadius:6,color:'var(--text)',padding:'5px 10px',fontSize:12}}>
            <option value="">All Actions</option>
            {['login','create','edit','delete'].map(a=><option key={a} value={a}>{a}</option>)}
          </select>
          <select value={fSection} onChange={e=>setFSection(e.target.value)} style={{background:'var(--bg3)',border:'1px solid var(--border2)',borderRadius:6,color:'var(--text)',padding:'5px 10px',fontSize:12}}>
            <option value="">All Sections</option>
            {Object.entries(SECTION_LABELS).map(([k,v])=><option key={k} value={k}>{v}</option>)}
          </select>
          <button className="btn btn-secondary" onClick={load}>↻ Refresh</button>
        </div>
      </div>
      <div style={{flex:1,overflow:'auto',padding:16}}>
        {loading ? <Empty icon="⏳" title="Loading..." />
          : logs.length === 0 ? <Empty icon="📋" title="No activity yet" sub="User actions will appear here." />
          : <table className="data-table"><thead><tr>
              <th style={{width:150}}>When</th><th style={{width:140}}>User</th><th style={{width:90}}>Action</th><th style={{width:130}}>Section</th><th style={{width:110}}>Product · Market</th><th>Changes</th>
            </tr></thead>
            <tbody>{logs.map(log => {
              const isOpen = expanded[log.id]
              return <tr key={log.id}>
                <td style={{fontSize:11,color:'var(--text3)',whiteSpace:'nowrap'}}>{fmt(log.created_at)}</td>
                <td style={{fontSize:12,fontWeight:600}}>{log.user_name||'—'}</td>
                <td><span style={{fontSize:11,fontWeight:700,color:ACTION_COLORS[log.action]||'var(--text)',textTransform:'uppercase'}}>{log.action}</span></td>
                <td style={{fontSize:12}}>{SECTION_LABELS[log.section]||log.section||'—'}</td>
                <td style={{fontSize:12,fontFamily:'DM Mono,monospace'}}>{log.record_id||'—'}</td>
                <td>
                  <div onClick={()=>setExpanded(e=>({...e,[log.id]:!e[log.id]}))} style={{cursor:'pointer'}}>
                    {isOpen ? renderChanges(log) : <span style={{fontSize:12,color:'var(--accent)'}}>
                      {log.action==='login' ? 'Signed in' : log.action==='edit' ? `${Object.keys(log.changes||{}).length} field(s) changed — click to view` : log.action==='create' ? 'Created — click to view' : 'Deleted — click to view'}
                    </span>}
                  </div>
                </td>
              </tr>
            })}</tbody>
          </table>}
      </div>
    </div>
  )
}
